import { z } from "zod";

export const assessmentDateSchema = z.object({
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export type AssessmentDate = z.infer<typeof assessmentDateSchema>;
